import React from "react";
import Button from "../../../components/common/button";
import { FileText, Download } from "react-feather";
import moment from "moment";
import { IReport } from "../../../interfaces/report";
import { Link } from "react-router-dom";

type ReportStatus = "complete" | "processsing" | "submitted";

interface IProps {
	report: IReport | any;
}

const ReportRow: React.FC<IProps> = ({ report }) => (
	<tr>
		<td className="company-column">{report.requested_by.name || "Company Name"}</td>
		<td className="type-column">{report.report_type || "Report Type"}</td>
		<td className="date-column">{moment(report.request_date).format("MMM DD YYYY HH:mm a")}</td>
		<td className="description-column">{report.description || "Description"}</td>
		<td className="actions-column">
			<div className="action-buttons">
				<span className={`status-badge ${report.status.toLowerCase()}`}>
					<FileText size={17} className="mr-2" />
					{report.status}
				</span>

				{report.status === "UPLOADED" && (
					<Link to={`${report.report_uri}`} target="_blank">
						<Button outline color="primary" className="download-btn">
							<Download size={17} className="mr-2" />
							Download
						</Button>
					</Link>
				)}
			</div>
		</td>
	</tr>
);

export default ReportRow;
